import { type ZodSchema, z } from 'zod'

/**
 * Validates a JSON string against a Zod schema
 * and returns the parsed data strongly typed.
 *
 * @param jsonString the JSON string to validate
 * @param schema the Zod schema to validate against
 * @returns the parsed data strongly typed
 */
export function validateJson<T extends ZodSchema>(
  jsonString: string | null | undefined,
  schema: T
): z.output<T> {
  try {
    if (!jsonString) {
      throw new Error('No JSON string provided')
    }

    const parsedJson = JSON.parse(jsonString)
    const validatedData = schema.parse(parsedJson)
    return validatedData
  } catch (error) {
    // Handle deserialization or validation errors
    if (error instanceof SyntaxError) {
      throw new Error('Invalid JSON string')
    }
    if (error instanceof z.ZodError) {
      throw new Error(`Validation failed: ${error.message}`)
    }
    throw error // Rethrow other unexpected errors
  }
}
